import React, { useState, useEffect } from "react";
import axios from "axios";
import Loader from "../components/Loader";

function Getlluser() {
    	const [loading, setloading] = useState(true);
			const [user, setuser] = useState([]);
			const [error, seterror] = useState();

	useEffect(() => {
		try {
			axios
				.get("https://online-hotels-booking-system-server.vercel.app/api/users/getalluser")
				.then((response) => {
					setuser(response.data);
					setloading(false);
				});
		} catch (error) {
			seterror(true);

			setloading(false);
		}
	}, []);

	return (
		<div className="row">
			<div className="col-md-12">
				<h1>Users</h1>
				{loading && <Loader />}
		

				<table className="table table-bordered table-dark">
					<thead className="bs">
						<tr>
							<th>Name</th>
							<th> Email</th>
							<th> isAdmin</th>
						
						</tr>
					</thead>
					<tbody>
						{user.length &&
							user.map((users) => {
								return (
									<tr>
										<td>{users.name}</td>
										<td>{users._id}</td>

										<td>{users.isAdmin ? 'YES' : 'NO'}</td>
									</tr>
								);
							})}
					</tbody>
				</table>
			</div>
		</div>
	);
}

export default Getlluser;
